module.exports = __webpack_public_path__ + "img/定制开发.815ae89c.815ae89c.png";